import React from 'react'
import Moment from 'react-moment';

function StandardDate(props) {
    return (
        <Moment format='L'>{props.children}</Moment>
    );
}

export default StandardDate